import React, { Component } from 'react'
import { observer } from "mobx-react"
import { getAllUserWagers } from '../../api-calls/wagers';
import { getAllUserWagers as getAllUserPoolWagers } from '../../api-calls/poolWagers';
import { List, Icon, Menu, Dropdown, Tooltip } from 'antd';
import { FacebookShareButton, TwitterShareButton, EmailShareButton, TelegramShareButton, WhatsappShareButton } from 'react-share'
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { FaTelegram, FaWhatsapp, FaUserSecret } from 'react-icons/fa';
import MyBetsPageCard from './MyBetsPageCard';
import MyBetTable from '../layoutComponents/MyBetTable';
import MyPoolBetsTable from '../layoutComponents/MyPoolBetsTable';
const betCopy = "Take the other side of the bet I just made on mevu.bet!";
@observer(["eventStore", "UserStore", "AuthStore", "ViewStore", "web3Store", "AdminStore", "TeamStore"])
class MyBetsPage extends Component {

    constructor(props) {
        super(props);
        this.state = { showLoading: true, dataGot: false, finalDataGot: false }
        this.props.eventStore.queryEvents();
        this.props.TeamStore.queryTeams();
        this.getData = this.getData.bind(this);
    }

    async componentWillMount() {
        this.props.ViewStore.changeView('My Bets');
        this.props.ViewStore.changeCurrentPage('MyBets');

    }

    componentWillUnmount() {
        this.props.ViewStore.changePreviousPage('MyBets')
    }

    getData() {
        let self = this;
        getAllUserWagers(self.props.UserStore.user._id).then(() => {
            getAllUserPoolWagers(self.props.UserStore.user._id).then(() => {
                self.setState({ showLoading: false, dataGot: true });
                
            })

        });
    }


    render() {
        const { eventStore, TeamStore, AdminStore } = this.props;
        let userId = this.props.UserStore.user._id;
        let wagerObjectList = [];
        let poolWagerObjectList = [];


        this.props.UserStore.bets.map((wager) => {
            let event = eventStore.events.get(wager.eventId);
            if (wager.maker == this.props.UserStore.user._id) {
                if (wager.cancelled) {
                    wagerObjectList.push({
                        wager: wager,
                        maker: true,
                        status: "cancelled"
                    });
                } else if (wager.taker == "" && Date.now() / 1000 > event.startTime + event.duration) {
                    wagerObjectList.push({
                        wager: wager,
                        maker: true,
                        status: "untaken-postgame"
                    });
                } else if (wager.taker == "" && Date.now() / 1000 < event.startTime + event.duration) {
                    wagerObjectList.push({
                        wager: wager,
                        maker: true,
                        status: "untaken-pregame"
                    });
                } else if (wager.taker != "" && Date.now() / 1000 < event.startTime + event.duration) {
                    wagerObjectList.push({
                        wager: wager,
                        maker: true,
                        status: "taken-pregame"
                    });
                } else if (wager.taker != "" && Date.now() / 1000 < event.startTime + event.duration + AdminStore.oraclePeriod && Date.now() / 1000 > event.startTime + event.duration && wager.makerWinVote == 0 && wager.takerWinVote == 0) {
                    wagerObjectList.push({
                        wager: wager,
                        maker: true,
                        status: "novotes-postgameprefinalized"
                    });
                } else if (wager.taker != "" && !wager.settled && Date.now() / 1000 > event.startTime + event.duration + AdminStore.oraclePeriod && Date.now() / 1000 > event.startTime + event.duration && wager.makerWinVote == 0 && wager.takerWinVote == 0) {
                    wagerObjectList.push({
                        wager: wager,
                        maker: true,
                        status: "novotes-postgamepostfinalized"
                    });
                } else if (wager.taker != "" && Date.now() / 1000 < event.startTime + event.duration + AdminStore.oraclePeriod && Date.now() / 1000 > event.startTime + event.duration && wager.makerWinVote !== 0 && wager.takerWinVote == 0) {
                    wagerObjectList.push({
                        wager: wager,
                        maker: true,
                        status: "onlymakervoted-preeventfinalized"
                    });
                } else if (wager.taker != "" && Date.now() / 1000 < event.startTime + event.duration + AdminStore.oraclePeriod && Date.now() / 1000 > event.startTime + event.duration && wager.makerWinVote == 0 && wager.takerWinVote !== 0) {
                    wagerObjectList.push({
                        wager: wager,
                        maker: true,
                        status: "onlytakervoted-preeventfinalized"
                    });
                } else if (wager.taker != "" && Date.now() / 1000 > event.startTime + event.duration && wager.makerWinVote !== 0 && wager.takerWinVote !== 0
                    && wager.makerWinVote == wager.takerWinVote) {
                    wagerObjectList.push({
                        wager: wager,
                        maker: true,
                        status: "settled-nodispute"
                    });
                } else if (wager.taker != "" && Date.now() / 1000 < event.startTime + event.duration + AdminStore.oraclePeriod && Date.now() / 1000 > event.startTime + event.duration && wager.makerWinVote !== 0 && wager.takerWinVote !== 0
                    && wager.makerWinVote !== wager.takerWinVote) {
                    wagerObjectList.push({
                        wager: wager,
                        maker: true,
                        status: "dispute-preeventfinalize"
                    });
                }
                else if (wager.taker != "" && Date.now() / 1000 > event.startTime + event.duration && wager.makerWinVote !== 0 && wager.takerWinVote !== 0
                    && wager.makerWinVote !== wager.takerWinVote && Date.now() / 1000 > event.startTime + event.duration + AdminStore.oraclePeriod && !wager.settled) {
                    wagerObjectList.push({
                        wager: wager,
                        maker: true,
                        status: "dispute-settlednotpaid"
                    });
                }
                else if (wager.taker != "" && Date.now() / 1000 > event.startTime + event.duration && wager.makerWinVote !== 0 && wager.takerWinWinVote !== 0
                    && wager.makerWinVote !== wager.takerWinVote && Date.now() / 1000 > event.startTime + event.duration + AdminStore.oraclePeriod && wager.settled) {
                    wagerObjectList.push({
                        wager: wager,
                        maker: true,
                        status: "dispute-settledpaid"
                    });
                } else if (wager.taker != "" && !wager.settled && Date.now() / 1000 > event.startTime + event.duration + AdminStore.oraclePeriod && wager.makerWinVote !== 0 && wager.takerWinVote == 0) {
                    wagerObjectList.push({
                        wager: wager,
                        maker: true,
                        status: "onlymakervoted-posteventfinalized"
                    });
                } else if (wager.taker != "" && !wager.settled && Date.now() / 1000 > event.startTime + event.duration + AdminStore.oraclePeriod && wager.makerWinVote == 0 && wager.takerWinVote !== 0) {
                    wagerObjectList.push({
                        wager: wager,
                        maker: true,
                        status: "onlytakervoted-posteventfinalized"
                    });
                } else if (wager.settled) {
                    wagerObjectList.push({
                        wager: wager,
                        maker: true,
                        status: "settled"
                    });

                }
            }

            if (wager.taker == this.props.UserStore.user._id) {
                if (wager.cancelled) {
                    wagerObjectList.push({
                        wager: wager,
                        taker: true,
                        status: "cancelled"
                    });
                } else if (wager.taker == "" && Date.now() / 1000 > event.startTime + event.duration) {
                    wagerObjectList.push({
                        wager: wager,
                        taker: true,
                        status: "untaken-postgame"
                    });
                } else if (wager.taker == "" && Date.now() / 1000 < event.startTime + event.duration) {
                    wagerObjectList.push({
                        wager: wager,
                        taker: true,
                        status: "untaken-pregame"
                    });
                } else if (wager.taker != "" && Date.now() / 1000 < event.startTime + event.duration) {
                    wagerObjectList.push({
                        wager: wager,
                        taker: true,
                        status: "taken-pregame"
                    });

                } else if (wager.taker != "" && Date.now() / 1000 < event.startTime + event.duration + AdminStore.oraclePeriod && Date.now() / 1000 > event.startTime + event.duration && wager.makerWinVote == 0 && wager.takerWinVote == 0) {
                    wagerObjectList.push({
                        wager: wager,
                        taker: true,
                        status: "novotes-postgameprefinalized"
                    });
                } else if (wager.taker != "" && !wager.settled && Date.now() / 1000 > event.startTime + event.duration + AdminStore.oraclePeriod && Date.now() / 1000 > event.startTime + event.duration && wager.makerWinVote == 0 && wager.takerWinVote == 0) {
                    wagerObjectList.push({
                        wager: wager,
                        taker: true,
                        status: "novotes-postgamepostfinalized"
                    });
                } else if (wager.taker != "" && Date.now() / 1000 < event.startTime + event.duration + AdminStore.oraclePeriod && Date.now() / 1000 > event.startTime + event.duration && wager.makerWinVote !== 0 && wager.takerWinVote == 0) {
                    wagerObjectList.push({
                        wager: wager,
                        taker: true,
                        status: "onlymakervoted-preeventfinalized"
                    });

                } else if (wager.taker != "" && Date.now() / 1000 < event.startTime + event.duration + AdminStore.oraclePeriod && Date.now() / 1000 > event.startTime + event.duration && wager.makerWinVote == 0 && wager.takerWinVote !== 0) {
                    wagerObjectList.push({
                        wager: wager,
                        taker: true,
                        status: "onlytakervoted-preeventfinalized"
                    });
                } else if (wager.taker != "" && Date.now() / 1000 > event.startTime + event.duration && wager.makerWinVote !== 0 && wager.takerWinVote !== 0
                    && wager.makerWinVote == wager.takerWinVote) {
                    wagerObjectList.push({
                        wager: wager,
                        taker: true,
                        status: "settled-nodispute"
                    });
                } else if (wager.taker != "" && Date.now() / 1000 < event.startTime + event.duration + AdminStore.oraclePeriod && Date.now() / 1000 > event.startTime + event.duration && wager.makerWinVote !== 0 && wager.takerWinVote !== 0
                    && wager.makerWinVote !== wager.takerWinVote) {
                    wagerObjectList.push({
                        wager: wager,
                        taker: true,
                        status: "dispute-preeventfinalize"
                    });
                }
                else if (wager.taker != "" && wager.makerWinVote !== 0 && wager.takerWinVote !== 0
                    && wager.makerWinVote !== wager.takerWinVote && Date.now() / 1000 > event.startTime + event.duration + AdminStore.oraclePeriod && !wager.settled) {
                    wagerObjectList.push({
                        wager: wager,
                        taker: true,
                        status: "dispute-settlednotpaid"
                    });
                }
                else if (wager.taker != "" && Date.now() / 1000 > event.startTime + event.duration + AdminStore.oraclePeriod && wager.makerWinVote !== 0 && wager.takerWinVote !== 0
                    && wager.makerWinVote !== wager.takerWinVote && wager.settled) {
                    wagerObjectList.push({
                        wager: wager,
                        taker: true,
                        status: "dispute-settledpaid"
                    });
                } else if (wager.taker != "" && !wager.settled && Date.now() / 1000 > event.startTime + event.duration + AdminStore.oraclePeriod && wager.makerWinVote !== 0 && wager.takerWinVote == 0) {
                    wagerObjectList.push({
                        wager: wager,
                        taker: true,
                        status: "onlymakervoted-posteventfinalized"
                    });
                } else if (wager.taker != "" && !wager.settled && Date.now() / 1000 > event.startTime + event.duration + AdminStore.oraclePeriod && wager.makerWinVote == 0 && wager.takerWinVote !== 0) {
                    wagerObjectList.push({
                        wager: wager,
                        taker: true,
                        status: "onlytakervoted-posteventfinalized"
                    });
                } else if (wager.settled) {
                    wagerObjectList.push({
                        wager: wager,
                        taker: true,
                        status: "settled"
                    });
                }
            }

            if (wagerObjectList.length == 0) {
                wagerObjectList = undefined;
            }
        });
        this.props.UserStore.poolBets.map((wager) => {
            let event = eventStore.events.get(wager.eventId);

            if (Date.now() / 1000 < event.startTime + event.duration && !event.cancelled) {
                //Game has not ended
                poolWagerObjectList.push({
                    wager: wager,
                    status: "pregame"
                });
            } else if (wager.cancelled) {
                poolWagerObjectList.push({
                    wager: wager,
                    status: "cancelled"
                });
            } else if ((Date.now() / 1000 > event.startTime + event.duration + AdminStore.oraclePeriod || event.cancelled) && !wager.settled) {
                // game has ended
                poolWagerObjectList.push({
                    wager: wager,
                    status: "over-unsettled"
                });
            } else if (Date.now() / 1000 > event.startTime + event.duration && Date.now() / 1000 < (event.startTime + event.duration + AdminStore.oraclePeriod) && !wager.settled) {
                // game has ended
                poolWagerObjectList.push({
                    wager: wager,
                    status: "over-oracles"
                });
            } else if (Date.now() / 1000 > event.startTime + event.duration + AdminStore.oraclePeriod && wager.settled) {
                if (wager.isWinner) {
                    poolWagerObjectList.push({
                        wager: wager,
                        status: "settled-won"
                    });
                } else {
                    poolWagerObjectList.push({
                        wager: wager,
                        status: "settled-lost"
                    });
                }
            }
        });

        if (this.state.dataGot && !this.state.finalDataGot) {
            this.setState({finalDataGot: true});
        }

        if (!this.state.dataGot && this.props.UserStore.loaded && this.props.eventStore.loaded && this.props.TeamStore.loaded) {

            this.getData();

        }
  


        return (
            <List
                grid={{
                    gutter: 16, xs: 1, sm: 1, md: 1, lg: 1, xl: 1, xxl: 1,
                }} >
                <List.Item key={"1-1"} style={{ padding: "15px" }}>
                    <span className="raleway" style={{ fontSize: "18pt", color: 'white' }}>1 - 1</span>
                    <div style={{ backgroundColor: "rgba(0,0,0,0.4)", textAlign: "center", height: "550px", overflow: "scroll" }}>
                        {/* {this.state.showLoading ? <Icon style={{ fontSize: "20pt", color: "#1890ff" }} type="loading" /> : ""} */}
                        {/* <List
                    grid={{
                        gutter: 16, xs: 1, sm: 1, md: 1, lg: 2, xl: 2, xxl: 2,
                    }} > */}
                        {/* {this.props.UserStore.bets.map((wager) => {
                            const menu = (
                                <Menu theme={"dark"} style={{ width: "50px" }}>
                                    <Menu.Item>
                                        <FacebookShareButton children={<Icon style={{ fontSize: "26px", color: 'white' }} type="facebook" />} quote={betCopy} url={"https://dapp.mevu.bet/take_bet/" + wager._id} />
                                    </Menu.Item>
                                    <Menu.Item>
                                        <TwitterShareButton children={<Icon style={{ fontSize: "26px", color: 'white' }} type="twitter" />} title={betCopy} url={"https://dapp.mevu.bet/take_bet/" + wager._id} />
                                    </Menu.Item>
                                    <Menu.Item>
                                        <TelegramShareButton children={

                                            <FaTelegram style={{ fontSize: "26px", color: 'white' }} />
                                        }
                                            title={betCopy} url={"https://dapp.mevu.bet/take_bet/" + wager._id} />
                                    </Menu.Item>
                                    <Menu.Item>
                                        <WhatsappShareButton children={

                                            <FaWhatsapp style={{ fontSize: "26px", color: 'white' }} />
                                        }
                                            title={betCopy} url={"https://dapp.mevu.bet/take_bet/" + wager._id} />
                                    </Menu.Item>
                                    <Menu.Item>
                                        <EmailShareButton children={<Icon style={{ fontSize: "26px", color: 'white' }} type="mail" />} subject={betCopy} url={"https://dapp.mevu.bet/take_bet/" + wager._id} />
                                    </Menu.Item>
                                </Menu>
                            ); */}
                        <MyBetTable dataGot={this.state.finalDataGot} data={wagerObjectList} />
                        {/* return <div>

                                <MyBetsPageCard wager={wager} />

                              
                                <p style={{ color: "rgba(255,255,255,0.4)" }} className="space-mono">SMART-CONTRACT ID: <span className="eth-address" style={{ cursor: 'pointer' }}>
                                    <CopyToClipboard text={wager.bytes32Id}>
                                        <Tooltip placement="bottom" title="Click to copy">
                                            <span style={{ backgroundColor: "rgba(255,255,255,0.2)", borderRadius: 4, fontSize: "12pt" }}>{wager.bytes32Id.slice(0, 6)}...</span>
                                        </Tooltip>
                                    </CopyToClipboard>
                                </span>
                                </p>
                                {!wager.cancelled && !wager.settled && wager.taker == "" ? <div> <Dropdown overlay={menu}>
                                    <a className="ant-dropdown-link" href="#">
                                        <Icon style={{ fontSize: "26px" }} type="share-alt" />
                                    </a>
                                </Dropdown>
                                </div> : <div><Icon style={{ fontSize: "26px", color: "rgba(255,255,255,0.4)" }} type="share-alt" /></div>}
                                <hr style={{ margin: '0.5em', color: "rgba(255,255,255,0.4)" }} />
                            </div>
                        })} */}
                        {/* </List> */}
                        {/* {wager._id} - {wager.maker == userId ? "MAKER" : "TAKER"} - {wager.settled ? "Settled" : wager.cancelled ? "cancelled" : "open"} */}
                    </div>
                </List.Item>
                <List.Item key={"POOL"} style={{ padding: "15px" }}>
                    <span className="raleway" style={{ fontSize: "18pt", color: 'white' }}>POOL</span>
                    <div style={{ backgroundColor: "rgba(0,0,0,0.4)", textAlign: "center", height: "550px", overflow: "scroll" }}>
                        <MyPoolBetsTable dataGot={this.state.finalDataGot} data={poolWagerObjectList} />
                    </div>
                </List.Item>
            </List>
        )
    }
}

export default MyBetsPage;



// WEBPACK FOOTER //
// ./src/components/appComponents/MyBetsPage.js